type Input = {
	paymentId: string;
	source: string;
	productId: string;
	planId: string;
	amount: number;
	tenantId?: string;
};

const handlePaymentSuccess = async (_req: Input) => {
	return true;
};

export default handlePaymentSuccess;
